import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-course-history",
  templateUrl: "./course-history.component.html",
  styleUrls: ["./course-history.component.css"]
})
export class CourseHistoryComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

}
